import { api } from "./client";
import type { Appointment, PaginatedResponse } from "./types";

export interface AppointmentFilters {
  startDate?: string;
  endDate?: string;
  professionalId?: string;
  patientId?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface CreateAppointmentData {
  patientId: string;
  professionalId: string;
  procedureId: string;
  date: string;
  startTime: string;
  endTime: string;
  notes?: string;
}

export const appointmentsService = {
  async list(filters?: AppointmentFilters): Promise<PaginatedResponse<Appointment>> {
    return api.get<PaginatedResponse<Appointment>>("/appointments", filters);
  },

  async getById(id: string): Promise<Appointment> {
    return api.get<Appointment>(`/appointments/${id}`);
  },

  async create(data: CreateAppointmentData): Promise<Appointment> {
    return api.post<Appointment>("/appointments", data);
  },

  async update(id: string, data: Partial<CreateAppointmentData>): Promise<Appointment> {
    return api.put<Appointment>(`/appointments/${id}`, data);
  },

  async updateStatus(id: string, status: string, cancelReason?: string): Promise<Appointment> {
    return api.patch<Appointment>(`/appointments/${id}/status`, { status, cancelReason });
  },

  async cancel(id: string, reason?: string): Promise<void> {
    return api.delete(`/appointments/${id}`);
  },
};
